import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { HOME_I18N } from "../i18n/home";

export default function SprintTimeline() {
  const { lang } = useLang();
  const t = HOME_I18N[lang].sprint;

  return (
    <section className="section bg-white relative" data-testid="sprint-section">
      <div className="container-x">
        <div className="max-w-3xl">
          <span className="eyebrow">{t.eyebrow}</span>
          <h2 className="mt-3 h2-section">
            {t.title1}<br />
            <span className="text-[#2563EB]">{t.titleAccent}</span>
          </h2>
          <p className="mt-5 body-lg max-w-2xl">{t.desc}</p>
        </div>

        <div className="mt-16 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {t.steps.map((s, i) => (
            <motion.div
              key={s.t}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: (i % 3) * 0.06 }}
              className="relative rounded-2xl border border-slate-200 bg-[#F8FAFC] p-7"
              data-testid={`sprint-step-${i}`}
            >
              <div className="flex items-baseline gap-3">
                <span className="font-heading text-3xl font-extrabold text-[#2563EB]/25">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="h-px flex-1 bg-gradient-to-r from-[#2563EB]/20 to-transparent" />
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-[#07111F]">{s.t}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#334155]">{s.d}</p>
            </motion.div>
          ))}
        </div>

        <p className="mt-10 max-w-2xl text-sm text-[#334155]/80">{t.note}</p>
      </div>
    </section>
  );
}
